export interface instrumentType {
  id: number;
  name: String;
}
export const instrumentTypes: instrumentType[] = [
  {
    id: 0,
    name: 'NO APLICA',
  },
  {
    id: 30,
    name: 'TARJETA DE CRÉDITO',
  },
  {
    id: 30,
    name: 'TARJETA DE DÉBITO',
  },
  {
    id: 32,
    name: 'TARJETA PREPAGADA',
  },
  {
    id: 33,
    name: 'LIBRETA DE AHORRO.',
  },
  {
    id: 34,
    name: 'CHEQUES',
  },
  {
    id: 35,
    name: 'CAJA DE SEGURIDAD',
  },
  {
    id: 36,
    name: 'CHEQUES DE GERENCIA',
  },
  {
    id: 37,
    name: 'BONOS DE LA DEUDA PUBLICA',
  },
  {
    id: 38,
    name: 'OPERACIONES CAMBIARIAS',
  },
  {
    id: 39,
    name: 'DEPÓSITOS A PLAZO FIJO',
  },
  {
    id: 40,
    name: 'CUENTA CORRIENTE',
  },
  {
    id: 41,
    name: 'CUENTA DE AHORRO',
  },
  {
    id: 42,
    name: 'FIDEICOMISO.',
  },
  {
    id: 43,
    name: 'CRÉDITO HIPOTECARIO',
  },
  {
    id: 44,
    name: 'CRÉDITO DE VEHÍCULO',
  },
  {
    id: 45,
    name: 'CRÉDITO AGRICOLA',
  },
  {
    id: 46,
    name: 'CRÉDITO PERSONAL',
  },
  {
    id: 47,
    name: 'MICROCREDITO',
  },
  {
    id: 48,
    name: 'CRÉDITO COMERCIAL',
  },
  {
    id: 49,
    name: 'CRÉDITO AL TURISMO',
  },
  {
    id: 50,
    name: 'ATENCIÓN AL CLIENTE Y SERVICIOS DE OFICINA',
  },
];

export const instruments = [
  'CAPTACIONES  Y OBLIGACIONES CON BANAVIH',
  'CAPTACIONES Y OBLIGACIONES CON B.C.V',
  'CUENTAS CORRIENTES INACTIVAS ',
  'CUENTAS CORRIENTES NO REMUNERADAS',
  'CUENTAS CORRIENTES REMUNERADAS',
  'CUENTAS CORRIENTES SEGÚN CONVENIO CAMBIARIO N°20',
  'DEPÓSITO A PLAZO',
  'DEPOSITO A PLAZO FIJO SEGÚN CONVENIO CAMBIARIO N°20',
  'DEPÓSITOS DE AHORRO',
  'DEPÓSITOS DE AHORRO INACTIVOS',
  'DEPOSITOS DE AHORRO SEGÚN CONVENIO CAMBIARIO N° 20',
  'DEPÓSITOS Y CERTIFICADOS  A LA VISTA RESTRINGIDOS',
  'DEPÓSITOS Y CERTIFICADOS A LA VISTA',
  'FIDEICOMISOS DE ADMINISTRACIÓN ',
  'FIDEICOMISOS DE GARANTIA',
  'FIDEICOMISOS DE GARANTIA MIXTAS',
  'FIDEICOMISOS DE INVERSIÓN ',
  'INVERSIONES CEDIDAS',
  'OBLIGACIONES POR OPERACIONES CON MESA DE DINERO',
  'OTRAS CAPTACIONES RESTRINGIDAS',
  'OTRAS OBLIGACIONES A LA VISTA',
  'OTRAS OBLIGACIONES POR INTERMEDIACIÓN FINANCIERAS',
  'OTROS FIDEICOMISOS',
  'OTROS FINANCIAMIENTOS OBTENIDOS',
  'OTROS FONDOS Y DEPÓSITOS RESTRINGIDOS',
  'PARTICIPACIONES ',
  'TITULOS VALORES EMITIDOS POR LA INSTITUCIÓN',
];
